module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-chapter"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.permission) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "top": "0",
      "left": "0",
      "z-index": "10000",
      "background-color": "white",
      "transtition": "1s"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "height": "100%",
      "width": "100%",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "animation": "wiggle 1.5s infinite",
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/63377a4edcea6933891249a2/63377d0fd67f06ef48eef306_MORIEL%20ENGLISH%20LOGO.svg"
    }
  })])]) : _vm._e()]), _vm._v(" "), (_vm.course) ? _c('div', {
    staticClass: "chapter-course",
    style: (_vm.safeZones),
    attrs: {
      "id": "chapter-course"
    }
  }, _vm._l((_vm.course.section), function(section, idx) {
    return _c('div', {
      key: idx,
      staticClass: "chapter-section"
    }, [_c('h5', {
      staticClass: "sectionTitle"
    }, [_vm._v(_vm._s(section.name))]), _vm._v(" "), _vm._l((section.lesson), function(lesson, idx) {
      return _c('div', {
        key: idx,
        staticClass: "chapter-part",
        on: {
          "click": function($event) {
            return _vm.goTo(lesson, _vm.id, _vm.course.name)
          }
        }
      }, [_c('div', {
        staticClass: "container-course",
        attrs: {
          "id": ("lesson_" + (lesson.id))
        }
      }, [_c('div', {
        staticClass: "step shrink-on-active",
        class: {
          completed: _vm.progress.includes(lesson.id),
          active: _vm.nextLesson.id === lesson.id
        }
      }, [_c('div', {
        staticClass: "v-stepper-course"
      }, [_c('div', {
        staticClass: "circle"
      }, [(_vm.progress.includes(lesson.id)) ? _c('inline-svg', {
        staticClass: "check-v",
        attrs: {
          "src": require('../../assets/svg/GreenCheck.svg').default
        }
      }) : _vm._e()], 1), _vm._v(" "), (
        lesson.game &&
        lesson.game.permission !== 'unknown' &&
        lesson.game.permission !== _vm.permission &&
        _vm.permission !== 'paying' &&
        lesson.game.permission == 'registered'
      ) ? _c('inline-svg', {
        staticClass: "lockSign",
        attrs: {
          "width": "14px",
          "src": require('../../assets/svg/googleicon.svg').default
        }
      }) : _vm._e(), _vm._v(" "), (
        !lesson.game &&
        lesson.permission !== 'unknown' &&
        lesson.permission !== _vm.permission &&
        _vm.permission !== 'paying' &&
        lesson.permission == 'registered'
      ) ? _c('inline-svg', {
        staticClass: "lockSign",
        attrs: {
          "width": "14px",
          "src": require('../../assets/svg/googleicon.svg').default
        }
      }) : _vm._e(), _vm._v(" "), (section.lesson.length != idx + 1) ? _c('div', {
        staticClass: "line"
      }) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "content",
        class: {
          disabled: lesson &&
            lesson.permission !== 'unknown' &&
            lesson.permission !== _vm.permission &&
            _vm.permission !== 'paying',
          disabled2: lesson.game &&
            lesson.game.permission !== 'unknown' &&
            lesson.game.permission !== _vm.permission &&
            _vm.permission !== 'paying'
        }
      }, [_vm._v("\n              " + _vm._s(lesson.name) + "\n            ")]), _vm._v(" "), (
        lesson.game &&
        lesson.game.permission !== 'unknown' &&
        lesson.game.permission !== _vm.permission &&
        _vm.permission !== 'paying' &&
        lesson.game.permission == 'paying'
      ) ? _c('inline-svg', {
        staticClass: "lockSign",
        attrs: {
          "width": "14px",
          "src": require('../../assets/svg/lock.svg').default
        },
        on: {
          "click": _vm.goPay
        }
      }) : _vm._e(), _vm._v(" "), (
        !lesson.game &&
        lesson.permission !== 'unknown' &&
        lesson.permission !== _vm.permission &&
        _vm.permission !== 'paying' &&
        lesson.permission == 'paying'
      ) ? _c('inline-svg', {
        staticClass: "lockSign",
        attrs: {
          "width": "14px",
          "src": require('../../assets/svg/lock.svg').default
        },
        on: {
          "click": _vm.goPay
        }
      }) : _vm._e()], 1)])])
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": _vm.y === 'bottom',
      "left": _vm.x === 'left',
      "multi-line": true,
      "right": _vm.x === 'right',
      "timeout": _vm.timeout,
      "top": _vm.y === 'top',
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n    "), _c('div', {
    staticClass: "snackBtns"
  }, [(_vm.snacktype == 'reg') ? _c('v-btn', {
    attrs: {
      "color": "white",
      "flat": ""
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("chapter.chapter-course.login")) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.snacktype == 'paid') ? _c('v-btn', {
    attrs: {
      "color": "white"
    },
    on: {
      "click": _vm.goPay
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("chapter.chapter-course.pay")) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("chapter.chapter-course.exit")) + "\n      ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d972d78e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter/chapter-course.vue
// module id = 524
// module chunks = 0